import React from "react";
import Resume from "../assets/resume.pdf";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faDownload } from "@fortawesome/free-solid-svg-icons";

const HeroSection = () => {
  return (
    <>
      <section
        className="mt-44 mb-44 bg-fixed mx-auto max-w-screen-lg h-full pb-10 px-4 sm:px-8  z-40"
        id="home"
      >
        <div className="text-center space-y-4">
          <h1 className="text-white font-bold leading-normal">
          {/* <span className=""> Hello, I am</span> 
            <span className=""> Mukka Deepak</span> */}
            <p className="leading-normal text-3xl lg:text-7xl sm:text-5xl">Hello, I am <span className="hover:text-[#4A6CF7] transition-all duration-500 cursor-pointer">Mukka Deepak</span></p>
          </h1>
          <p className="text-gray-300 font-semibold text-center lg:text-xl sm:text-base text-xs xs:w-4/5 xs:mx-auto" draggable="true">
           <span className="text-red-300"> CS Undergrad </span> .
           <span className="text-green-300"> Developer </span> .
           <span className="text-violet-400"> Technical Writer </span>
          </p>
        </div>
        <div className="mt-12 flex flex-col md:flex-row justify-center items-center space-y-3 sm:space-x-6 sm:space-y-4">
          <a
            href={Resume}
            className="transition ease-out delay-150  hover:-translate-y-1 hover:scale-110 px-5 py-3 w-auto  bg-[#4A6CF7] hover:bg-[#3468d0cc] text-white text-center rounded-md shadow-md block"
            download={"Mukka_deepak_resume"}
          >
            <FontAwesomeIcon icon={faDownload} /> Download resume
          </a>
          <button>
            <a
              href="#aboutme"
              className="mt-2 md:-mt-4 transition ease-out delay-150  hover:-translate-y-1 hover:scale-110 px-5 py-3.5 w-auto  text-sm font-medium  focus:outline-none  focus:z-10 focus:ring-4 focus:ring-gray-700 hover:bg-gray-600 border-gray-600 text-gray-200 bg-gray-700 text-center rounded-md shadow-md block"
            >
              Know more
            </a>
          </button>
        </div>
      </section>
    </>
  );
};

export default HeroSection;
